var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.56 13.5C18.67 13.23 18.94 13.03 19.25 13.03C19.56 13.03 19.83 13.22 19.94 13.5C19.98 13.59 20 13.68 20 13.78V18.5C20 19.88 18.88 21 17.5 21H5.5C4.12 21 3 19.88 3 18.5V6.5C3 5.12 4.12 4 5.5 4H10.25C10.34 4 10.42 4.02 10.5 4.05C10.79 4.15 11 4.42 11 4.75C11 5.08 10.79 5.35 10.5 5.45C10.42 5.48 10.34 5.5 10.25 5.5H5.5C4.95 5.5 4.5 5.95 4.5 6.5V18.5C4.5 19.05 4.95 19.5 5.5 19.5H17.5C18.05 19.5 18.5 19.05 18.5 18.5V13.78C18.5 13.68 18.53 13.59 18.56 13.5L18.56 13.5ZM14.2499 4H18.2499C19.2099 4 19.9999 4.79 19.9999 5.75V9.75C19.9999 10.16 19.6599 10.5 19.2499 10.5C18.8399 10.5 18.4999 10.16 18.4999 9.75V6.56L12.5299 12.53C12.3799 12.68 12.1899 12.75 11.9999 12.75C11.8099 12.75 11.6199 12.68 11.4699 12.53C11.1799 12.24 11.1799 11.76 11.4699 11.47L17.4399 5.5H14.2499C13.8399 5.5 13.4999 5.16 13.4999 4.75C13.4999 4.34 13.8399 4 14.2499 4Z",
    fill: "#0077C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkIcon);
export default __webpack_public_path__ + "static/media/ExternalLinkIcon.9d27e301916852ace40177b2a66f0b32.svg";
export { ForwardRef as ReactComponent };